import { Headline } from '@almbrand/headline';
import { Modal } from '@almbrand/modal';
import { RichText } from '@almbrand/richtext';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setModal } from 'store/slices/modalSlice';

export const ModalComponent = () => {
	const dispatch = useAppDispatch();
	const { displayModal, modalProps } = useAppSelector((state) => state.modal);

	if (!displayModal || !modalProps) return null;

	const handleClose = () => dispatch(setModal({ displayModal: false }));

	let children;
	if (modalProps.isErrorModal) {
		// Error modal rendering
		children = (
			<>
				<div style={{ marginBottom: 'var(--spacing--md)' }}>
					<Headline
						fontColor='primary'
						size='default'
						title={modalProps.subtitle}
						variant='h2'
					/>
				</div>
				<div style={{ color: 'red' }}>{modalProps.content}</div>
				{modalProps.fields?.map((field, idx) => <div key={idx}>{field}</div>)}
			</>
		);
	} else {
		// Standard modal rendering
		children = (
			<>
				{modalProps.subtitle && (
					<div style={{ marginBottom: 'var(--spacing--md)' }}>
						<Headline
							fontColor='primary'
							size='default'
							title={modalProps.subtitle}
							variant='h2'
						/>
					</div>
				)}
				<RichText
					description={modalProps.content}
					className={modalProps.className}
				/>
				{modalProps.fields?.map((field, idx) => <div key={idx}>{field}</div>)}
			</>
		);
	}

	return (
		<Modal
			mode='default'
			mobileVariation='fullWidth'
			{...modalProps}
			handleClose={handleClose}
		>
			{children}
		</Modal>
	);
};
